import React, { useEffect, useState, useRef, Component } from 'react';
import { Mail, CheckCircle2, Clock, ArrowRight } from 'lucide-react';
import { SEO } from '../components/SEO';
const EMAIL = 'Hello@hireliocareerservices.com';
const SUBJECT = 'Inquiry from hireliocareerservices.com';
const GMAIL_COMPOSE = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(EMAIL)}&su=${encodeURIComponent(SUBJECT)}`;
const MAILTO = `mailto:${EMAIL}?subject=${encodeURIComponent(SUBJECT)}`;
export function Contact() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);
  return <div className="w-full pt-20 pb-24 bg-slate-50 dark:bg-navy-900/50 min-h-screen" data-id="element-234" data-mp="abwi0rqxscq2">
      <SEO title="Contact Hirelio | Request a Resume Writing Quote" description="Get in touch with Hirelio Career Services. Email us to request a personalized quote or schedule a free consultation with a professional resume writer." data-id="element-235" data-mp="15fyn3gnxn3m9" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 text-center" data-id="element-236" data-mp="1e8im4i84za7m">
        <h1 className="text-4xl md:text-5xl font-heading font-bold text-navy-900 dark:text-white mb-6" data-id="element-237" data-mp="1j6233pw7y139">
          Get in Touch
        </h1>
        <p className="text-lg text-slate-600 dark:text-slate-400 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-238" data-mp="qhwgexllu20s">
          Have questions about our services or need help choosing the right
          package? Email us directly and a career expert will get back to you
          within 24 hours.
        </p>

        <div className="bg-white dark:bg-navy-800 rounded-3xl p-8 md:p-12 shadow-xl border border-slate-100 dark:border-navy-700" data-id="element-239" data-mp="26wo9lcqkrdb5">
          <div className="w-16 h-16 bg-brand-50 dark:bg-navy-900 rounded-2xl flex items-center justify-center text-brand mx-auto mb-6" data-id="element-240" data-mp="2bug3udeozbii">
            <Mail size={28} data-id="element-241" data-mp="1m9gaam9vygw8" />
          </div>
          <h2 className="font-heading font-bold text-navy-900 dark:text-white text-2xl mb-2" data-id="element-242" data-mp="1h921v34dh4xo">
            Email Us
          </h2>
          <p className="text-slate-600 dark:text-slate-400 mb-6" data-id="element-243" data-mp="1w518e9bu2x0p">
            Tell us about your career goals and the services you're interested
            in.
          </p>

          <div ref={menuRef} className="relative inline-block" data-id="element-244" data-mp="13g2l6xsut4oj">
            <button type="button" onClick={() => setOpen(v => !v)} aria-haspopup="menu" aria-expanded={open} className="inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-600 text-white px-8 py-4 rounded-xl font-medium text-lg transition-all shadow-md hover:shadow-lg" data-id="element-245" data-mp="yhstwya92o87">
              {EMAIL} <ArrowRight size={20} data-id="element-246" data-mp="ko9x9hsn69no" />
            </button>

            {open && <div role="menu" className="absolute left-1/2 -translate-x-1/2 mt-3 w-64 bg-white dark:bg-navy-800 rounded-2xl shadow-xl border border-slate-100 dark:border-navy-700 p-2 z-20 animate-in fade-in zoom-in-95 duration-150" data-id="element-247" data-mp="fr1bz8c75pi7">
                <a href={GMAIL_COMPOSE} target="_blank" rel="noopener noreferrer" role="menuitem" onClick={() => setOpen(false)} className="flex items-center gap-3 px-4 py-3 rounded-xl text-left text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-navy-700 transition-colors" data-id="element-248" data-mp="2hhry7ehqbsbk">
                  <Mail size={18} className="text-brand shrink-0" data-id="element-249" data-mp="3146k9gcnuar1" />
                  Open in Gmail
                </a>
                <a href={MAILTO} role="menuitem" onClick={() => setOpen(false)} className="flex items-center gap-3 px-4 py-3 rounded-xl text-left text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-navy-700 transition-colors" data-id="element-250" data-mp="357w4xuq7s86s">
                  <Mail size={18} className="text-brand shrink-0" data-id="element-251" data-mp="2570zh2da0xnp" />
                  Use my default email app
                </a>
              </div>}
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-slate-500 dark:text-slate-400" data-id="element-252" data-mp="1v9muq00ptxb8">
          <span className="flex items-center gap-2" data-id="element-253" data-mp="2svk51a4xywc3">
            <Clock size={18} className="text-brand shrink-0" data-id="element-254" data-mp="2ny1xno6kop67" />
            We respond within 24 hours
          </span>
          <span className="flex items-center gap-2" data-id="element-255" data-mp="2ixxraqzdpatp">
            <CheckCircle2 size={18} className="text-emerald-500 shrink-0" data-id="element-256" data-mp="2j0s7g6bd09hb" />
            Your information is never shared with third parties
          </span>
        </div>
      </div>
    </div>;
}